<template>
  <Layout>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main';

export default {
  components: { Layout }
}
</script>
